import {ResourcesErrors} from '.';
import {ErrorAction, ErrorCode} from '@/services/ErrorService/ErrorService.constants';

import {HttpStatus} from '@specials/project-user';

export const errors: ResourcesErrors = {
  errorCodes: [
    {
      errorCodes: [ErrorCode.TestError],
      mb: {
        title: 'Что-то пошло не так',
        text: 'Пожалуйста, закройте экран и зайдите еще раз',
        isErrorCodeVisible: true,
      },
      web: {
        title: 'Что-то пошло не так',
        text: 'Пожалуйста закройте экран и зайдите еще раз',
        isErrorCodeVisible: true,
      },
    },
    {
      errorCodes: [ErrorCode.AuthRejectedBlackListError],
      mb: {
        title: 'Проект недоступен',
        text: 'Проект временно недоступен, зайдите позже',
        isErrorCodeVisible: true,
      },
      web: {
        title: 'Проект недоступен',
        text: 'Проект временно недоступен, зайдите позже',
        isErrorCodeVisible: true,
      },
    },
    {
      errorCodes: [ErrorCode.AuthRejectedWhiteListError],
      mb: {
        title: 'Проект недоступен',
        text: '12 декабря здесь будет доступ к вашему адвент‑календарю со сладкими итогами уходящего года, возвращайтесь позже!',
        isErrorCodeVisible: true,
      },
      web: {
        title: 'Проект недоступен',
        text: '12 декабря здесь будет доступ к вашему адвент‑календарю со сладкими итогами уходящего года, возвращайтесь позже!',
        isErrorCodeVisible: true,
      },
    },
    {
      errorCodes: [
        ErrorCode.AuthSsoError,
        ErrorCode.UnauthorizedError,
        ErrorCode.MbUserGuestError,
        ErrorCode.AuthProjectTokenError,
        ErrorCode.UserIsNotDefinedError,
        ErrorCode.SSOTokenNotActive,
        ErrorCode.CampaignNameAlreadyExist,
        ErrorCode.ProjectConfigNotFoundError,
      ],
      mb: {
        title: 'Что-то пошло не так',
        text: 'Пожалуйста, закройте экран и зайдите еще раз',
        isErrorCodeVisible: true,
      },
      web: {
        title: 'Что-то пошло не так',
        text: 'Пожалуйста закройте экран и зайдите еще раз',
        buttonText: 'Войти',
        isErrorCodeVisible: true,
        action: ErrorAction.Logout,
      },
    },
    {
      errorCodes: [
        ErrorCode.BadRequest,
        ErrorCode.HeaderValidation,
        ErrorCode.NotFound,
        ErrorCode.RequestValidation,
        ErrorCode.InternalServer,
        ErrorCode.QueryFailed,
        ErrorCode.SsoTokenIntrospect,
        ErrorCode.SsoUserInfo,
        ErrorCode.UserFetchStatisticsError,
        ErrorCode.InvalidUserInfoError,
        ErrorCode.ActivePrimaryDetailRequestError,
        ErrorCode.BundleAllRequestError,
        ErrorCode.PersonalInfoError,
        ErrorCode.ProductLoyalties,
        ErrorCode.GetProductLoyaltiesV2,
        ErrorCode.GetPortalUserId,
        ErrorCode.GetUserIdEmptyPayload,
      ],
      mb: {
        title: 'Что-то пошло не так',
        text: 'Перезагрузите страницу. Если не помогло, сделайте скриншот этого экрана и обратитесь в поддержку, мы поможем',
        isErrorCodeVisible: true,
        action: ErrorAction.Reload,
      },
      web: {
        title: 'Что-то пошло не так',
        buttonText: 'Перезагрузить',
        text: 'Перезагрузите страницу. Если не помогло, сделайте скриншот этого экрана и обратитесь в поддержку, мы поможем',
        action: ErrorAction.Reload,
        isErrorCodeVisible: true,
      },
    },
    {
      errorCodes: [ErrorCode.UserBanned],
      mb: {
        title: 'Пользователь забанен',
        text: 'К сожалению вы не можете воспользоваться сервисом. Обратитесь в поддержку',
        isErrorCodeVisible: true,
      },
      web: {
        title: 'Пользователь забанен',
        text: 'К сожалению вы не можете воспользоваться сервисом. Обратитесь в поддержку или авторируйтесь под другим номером телефона.',
        action: ErrorAction.Logout,
        buttonText: 'Войти под другим аккаунтом',
        isErrorCodeVisible: true,
      },
    },
    {
      errorCodes: [ErrorCode.InvalidAge],
      mb: {
        title: 'Некорректный возраст',
        text: 'К сожалению вы не можете воспользоваться сервисом',
        isErrorCodeVisible: true,
      },
      web: {
        title: 'Некорректный возраст',
        text: 'Вы можете авторизоваться под другим аккаунтом',
        buttonText: 'Войти под другим аккаунтом',
        isErrorCodeVisible: true,
        action: ErrorAction.Logout,
      },
    },
    {
      errorCodes: [ErrorCode.UserIsNotClient],
      mb: {
        title: 'Некорректные продукты лояльности',
        text: 'Оформите карту',
        isErrorCodeVisible: true,
      },
      web: {
        title: 'Некорректные продукты лояльности',
        text: 'Оформите карту',
        isErrorCodeVisible: true,
      },
    },
    {
      errorCodes: [ErrorCode.UnmatchedError, ErrorCode.BoundaryError],
      mb: {
        title: 'Что‑то пошло не так',
        text: 'Пожалуйста закройте экран и зайдите еще раз',
        isErrorCodeVisible: true,
      },
      web: {
        text: 'Перезагрузите страницу. Если не помогло, сделайте скриншот этого экрана и обратитесь в поддержку, мы поможем',
        title: 'Что‑то пошло не так',
        isErrorCodeVisible: true,
      },
    },
    {
      errorCodes: [ErrorCode.UndefinedError, ErrorCode.UnknownError],
      mb: {
        title: 'Что‑то пошло не так',
        text: 'Пожалуйста закройте экран и зайдите еще раз',
        isErrorCodeVisible: true,
      },
      web: {
        text: 'Перезагрузите страницу. Если не помогло, сделайте скриншот этого экрана и обратитесь в поддержку, мы поможем',
        title: 'Что‑то пошло не так',
        isErrorCodeVisible: true,
      },
    },
    {
      errorCodes: [ErrorCode.ShareError],
      mb: {
        title: 'Ошибка копирования',
        isErrorCodeVisible: true,
      },
      web: {
        title: '',
      },
    },
    {
      errorCodes: [ErrorCode.UserOnboardingFinishError],
      mb: {
        title: 'Ошибка завершения онбординга',
        isErrorCodeVisible: true,
      },
      web: {
        title: '',
      },
    },
    {
      errorCodes: [ErrorCode.UserNotificationsToggleError],
      mb: {
        title: 'Ошибка нотификаций',
        isErrorCodeVisible: true,
      },
      web: {
        title: '',
      },
    },
    {
      errorCodes: [ErrorCode.UserIsOpenedAllItemsToggleError],
      mb: {
        title: 'Ошибка сохранения флага открытия всех айтемов',
      },
      web: {
        title: '',
      },
    },
    {
      errorCodes: [ErrorCode.UserCheckIfItemIsAvailableError, ErrorCode.UserItemIsUnavailableError],
      mb: {
        title: 'Не удалось открыть конфету',
        text: 'Ошибка открытия конфеты',
        isErrorCodeVisible: true,
      },
      web: {
        title: '',
      },
    },
    {
      errorCodes: [ErrorCode.NewUserRegistrationError, ErrorCode.NewUserAuthorizationError],
      mb: {
        title: 'Все конфеты разобрали',
        text: 'Спецпроект «Секрет конфет» с итогами 2024 года завершен. До связи в 2025-м! Готовим еще много сюрпризов',
        isErrorCodeVisible: true,
      },
      web: {
        title: '',
      },
    },
    {
      errorCodes: [ErrorCode.ProjectStageNotAllowActionError],
      mb: {
        title: 'Все конфеты разобрали',
        text: 'Спецпроект «Секрет конфет» с итогами 2024 года завершен. До связи в 2025-м! Готовим еще много сюрпризов',
        isErrorCodeVisible: true,
      },
      web: {
        title: '',
      },
    },
    {
      errorCodes: [ErrorCode.UserItemOpenError, ErrorCode.UserNotEnoughEnergyError],
      mb: {
        title: 'Не удалось открыть конфету',
        text: 'Ошибка открытия конфеты',
        buttonText: 'Попробовать снова',
        isErrorCodeVisible: true,
        action: ErrorAction.ReopenItem,
      },
      web: {
        title: '',
      },
    },
    {
      errorCodes: [ErrorCode.UserCheckIfBonusIsAvailableError],
      mb: {
        title: 'Не удалось открыть конфету',
        text: 'Ошибка получения бонуса',
        isErrorCodeVisible: true,
      },
      web: {
        title: '',
      },
    },
    {
      errorCodes: [ErrorCode.UserItemBonusOpenError, ErrorCode.UserBuyBonusError],
      mb: {
        title: 'Не удалось открыть конфету',
        text: 'Ошибка получения бонуса',
        buttonText: 'Попробовать снова',
        isErrorCodeVisible: true,
        action: ErrorAction.ReopenBonus,
      },
      web: {
        title: '',
      },
    },
  ],
  httpCodes: [
    {
      httpCodes: [HttpStatus.SERVICE_UNAVAILABLE],
      mb: {
        title: 'Что-то пошло не так',
        text: 'Сервис временно недоступен. Мы уже работаем над решением проблемы.',
        isErrorCodeVisible: true,
      },
      web: {
        title: 'Что-то пошло не так',
        text: 'Сервис временно недоступен. Мы уже работаем над решением проблемы.',
        isErrorCodeVisible: true,
      },
    },
  ],
  fallback: {
    mb: {
      title: 'Что-то пошло не так',
      text: 'Пожалуйста закройте экран и зайдите еще раз',
      isErrorCodeVisible: true,
      buttonText: '',
    },
    web: {
      text: undefined,
      title: 'Что-то пошло не так',
      buttonText: 'Перезагрузить',
      isErrorCodeVisible: true,
      action: ErrorAction.LogoutWithReload,
    },
  },
};
